import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all assetAssignmentses
export const getAssetAssignments = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-assignments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-assignments:", error.response?.data || error);
    throw error;
  }
};

// GET a single assetAssignments
export const getAssetAssignmentsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-assignments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-assignments:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new assetAssignments
export const createAssetAssignments = async (assetAssignmentsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-assignments`, assetAssignmentsData);
    return response.data;
  } catch (error) {
    console.error("Error creating asset-assignments:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing assetAssignments
export const updateAssetAssignments = async (id, assetAssignmentsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-assignments/${id}`, assetAssignmentsData);
    return response.data;
  } catch (error) {
    console.error("Error updating asset-assignments:", error.response?.data || error);
    throw error;
  }
};

// DELETE a assetAssignments
export const deleteAssetAssignments = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-assignments/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting asset-assignments:", error.response?.data || error);
    throw error;
  }
};
